<template>
    <Card>
      <AjaxForm route="admin/Guild/Add">
        <div class="row">
          <div class="col-12 col-md-6">
            <CustomInput name="title" type="text" placeholder="عنوان..." label="عنوان"></CustomInput>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput name="is_open" type="select" label="وضعیت بازار" placeholder="وضعیت را انتخاب کنید"
                         :select-options="is_open_options" reduce_select="value"
                         v-model="g_status"
                         select-label="title">
            </CustomInput>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput name="date_open" v-model="date" label="تاریخ باز شدن" placeholder="تاریخ را انتخاب کنید" type="date" :date-time="true"></CustomInput>
          </div>
          <div class="col-12 col-md-6 d-flex">
            <label class="mr-3">تصویر بنر</label>
            <ImagePicker name="pic_id"></ImagePicker>
          </div>
        </div>
        <div class="row">
          <div class="col-9 col-md-5 mx-auto mt-3">
            <button type="submit" class="btn btn-success btn-block">ثبت اطلاعات صنف</button>
          </div>
        </div>
      </AjaxForm>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
import ImagePicker from "@/components/ImagePicker";
export default {
name: "GuildAdd",
  components: {ImagePicker, CustomInput, AjaxForm, Card, MasterLayout},
  data()
  {
    return{
      is_open_options : [{value : '1',title : 'باز'},{value : '0',title : 'بسته'}],
      date : null,
      g_status : null,
    }
  },
  async mounted()
  {
    this.setPageTitle('افزودن صنف');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  },
}
</script>

<style scoped>

</style>